import { Component } from '@angular/core';
export class TdLayoutFooterComponent {

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  /* tslint:disable-next-line */
  selector: 'td-layout-footer,td-layout-footer-inner',
  styleUrls: ['./layout-footer.component.css' ],
  templateUrl: './layout-footer.component.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TdLayoutFooterComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdLayoutFooterComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdLayoutFooterComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
